<template>
  <v-card>
    <v-toolbar card dense color="transparent">
      <v-toolbar-title>
        <h4>PRODUCTOS DEL CONJUNTO</h4>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        color="success"
        dark
        fab
        small
        icon
        @click="abrirDialogNuevoProducto"
      >
        <v-icon>add</v-icon>
      </v-btn>
    </v-toolbar>
    <v-divider></v-divider>
    <v-card-text class="pa-0">
      <template>
        <v-data-table
          :headers="headers"
          :items="conjuntoProductos"
          hide-actions
          class="elevation-0 table-styling"
        >
          <template slot="items" slot-scope="props">
            <td>
              <v-icon color="primary">album</v-icon>
            </td>
            <td>{{ props.item.descripcionProducto }}</td>
            <td class="text-lg-center">
              <v-text-field
                label="Cantidad"
                v-model="props.item.cantidad"
                type="number"
                :rules="[
                  () => props.item.cantidad > 0 || 'Debe ser mayor a cero!',
                ]"
                @change="updateProductoConjunto(props.item)"
              ></v-text-field>
            </td>
            <td class="text-xs-right">
              <!-- <v-btn
                flat
                icon
                color="grey"
                @click="getProductoConjunto(props.item.conjuntoId, props.item.productoId)"
              >
                <v-icon>edit</v-icon>
              </v-btn> -->
              <v-btn
                flat
                icon
                color="grey"
                :loading="$store.state.loadingDelete.show"
                @click="
                  deleteProductoConjunto(
                    props.item.conjuntoId,
                    props.item.productoId
                  )
                "
              >
                <v-icon>delete</v-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </template>
      <v-divider></v-divider>
    </v-card-text>
    <form-conjunto-producto
      :conjunto="conjunto"
      :conjuntoProducto="conjuntoProducto"
      ref="dialogProductoConjunto"
      @onConjuntoProductoAdded="onConjuntoProductoAdded"
      @onConjuntoProductoUpdated="onConjuntoProductoUpdated"
    ></form-conjunto-producto>
    <confirm ref="confirm"></confirm>
  </v-card>
</template>

<script>
//Componentes
import VWidget from "@/components/VWidget";
import confirm from "@/components/dialogs/Confirm";
import loadingAlert from "@/components/LoadingAlert";
import snackBar from "@/components/SnackBar";
import formConjuntoProducto from "./FormConjuntoProducto";

//Servicios
import conjuntoProductoService from "@/services/conjuntoProductoService";

export default {
  components: {
    VWidget,
    formConjuntoProducto,
    confirm,
    loadingAlert,
    snackBar,
  },
  props: {
    conjunto: {
      type: Object,
    },
  },
  watch: {
    conjunto: function (newConjunto) {
      this.getProductosConjunto();
      console.log("cambio producto conjunto productos");
      console.log(newConjunto);
      this.conjuntoProducto.conjuntoId = newConjunto.conjuntoId;
    },
  },
  data() {
    return {
      headers: [
        { text: "", align: "center", sortable: false },
        { text: "PRODUCTO", align: "center", value: "descripcionProducto" },
        { text: "CANTIDAD", align: "center", value: "cantidad" },
        { text: "ACCIONES", value: "acciones", align: "right" },
      ],
      conjuntoProductos: [],
      conjuntoProducto: {
        conjuntoId: 0,
        productoId: 0,
        cantidad: 0,
        producto: {
          productoId: 0,
          descripcionProducto: "",
        },
      },
    };
  },
  mounted() {
    this.getProductosConjunto();
  },
  methods: {
    setConjuntoId(conjuntoId) {
      this.conjuntoProducto.conjuntoId = conjuntoId;
    },
    abrirDialogNuevoProducto() {
      this.$store.state.tituloForm = "AGREGAR PRODUCTO AL CONJUNTO";
      this.$store.state.iconoForm = "/images/general/agregar-40.png";
      this.$refs.dialogProductoConjunto.resetForm();
      this.$refs.dialogProductoConjunto.openDialog();
    },
    getProductosConjunto() {
      let self = this;
      self.$store.state.loadingInfo.show = true;
      conjuntoProductoService
        .getAllByConjunto(self.conjunto.conjuntoId)
        .then((result) => {
          self.conjuntoProductos = result;
        })
        .catch((e) => {
          console.log(e);
          self.operationFailed(e);
        })
        .finally(() => {
          self.$store.state.loadingInfo.show = false;
        });
    },
    getProductoConjunto(conjuntoId, productoId) {
      let self = this;
      self.$store.state.loadingInfo.show = true;
      conjuntoProductoService
        .get(conjuntoId, productoId)
        .then((result) => {
          self.$store.state.tituloForm = "MODIFICAR PRODUCTO CONJUNTO";
          self.$store.state.iconoForm = "/images/general/actualizar-40.png";

          self.$refs.dialogProductoConjunto.resetForm();
          self.conjuntoProducto = result;
          self.$refs.dialogProductoConjunto.openDialog();
        })
        .catch((e) => {
          self.operationFailed(e);
          console.log(e);
        })
        .finally(() => {
          self.$store.state.loadingInfo.show = false;
        });
    },
    deleteProductoConjunto(conjuntoId, productoId) {
      let self = this;

      this.$refs.confirm
        .open(
          "ELIMINAR PRODUCTO CONJUNTO",
          "¿Estás seguro de eliminar el producto del conjunto?",
          { color: "red" }
        )
        .then((confirm) => {
          if (confirm) {
            self.$store.state.loadingDelete.show = true;

            conjuntoProductoService
              .delete(conjuntoId, productoId)
              .then((result) => {
                var i = this.conjuntoProductos.findIndex(
                  (obj) =>
                    obj.conjuntoId == conjuntoId && obj.productoId == productoId
                );
                self.conjuntoProductos.splice(i, 1);

                self.$store.state.snackbar.color = "success";
                self.$store.state.snackbar.text =
                  "Producto eliminado del conjunto con éxito";
                self.$store.state.snackbar.visible = true;
              })
              .catch((e) => {
                console.log(e);
                self.operationFailed(e);
              })
              .finally(() => {
                self.$store.state.loadingDelete.show = false;
              });
          } else {
            self.$store.state.snackbar.color = "error";
            self.$store.state.snackbar.text = "Operación cancelada";
            self.$store.state.snackbar.visible = true;
          }
        });
    },
    updateProductoConjunto(productoConjunto) {
      let self = this;
      if (productoConjunto.cantidad > 0) {
        conjuntoProductoService
          .update(productoConjunto)
          .then((result) => {
            self.$store.state.snackbar.color = "success";
            self.$store.state.snackbar.text = "Producto actualizado";
            self.$store.state.snackbar.visible = true;
          })
          .catch((e) => {
            self.operationFailed(e);
            console.log(e);
          });
      }
    },
    onConjuntoProductoAdded(conjuntoProducto) {
      this.conjuntoProductos.push(conjuntoProducto);
    },
    onConjuntoProductoUpdated(conjuntoProducto) {
      var i = this.conjuntoProductos.findIndex(
        (obj) =>
          obj.conjuntoId == conjuntoProducto.conjuntoId &&
          obj.productoId == conjuntoProducto.productoId
      );
      this.conjuntoProductos.splice(i, 1, conjuntoProducto);
    },
  },
};
</script>
